import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Row } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { FormGroup, InnerGroup } from '../FormGroup';
const Wrapper = styled.div `
  display: flex;
`;
export const Fields = styled.div `
  display: flex;
  flex: auto;
`;
export const Counter = styled.div `
  margin-right: 15px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ labelCompensation }) => labelCompensation && '26px'};
`;
export const Actions = styled.div `
  margin-left: 15px;
  margin-top: ${({ labelCompensation }) => labelCompensation && '26px'};
`;
const FieldsGroup = ({ labelCompensation = true, wrapperType = 'inner-group', children, actions, rowBody = true, counter, }) => (_jsxs(Wrapper, { as: wrapperType === 'inner-group' ? InnerGroup : FormGroup, children: [counter && _jsx(Counter, { labelCompensation: labelCompensation, children: counter }), _jsx(Fields, { as: rowBody ? Row : 'div', children: children }), actions && _jsx(Actions, { labelCompensation: labelCompensation, children: actions })] }));
export default React.memo(FieldsGroup);
